<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Test Package Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <template>
      <basic-heading :title="`Update ${formattedName}`" class="mb-3">
        <template #right-content>
          <header-button-group :button_config="button_config" />
        </template>
      </basic-heading>
      <permission-alert-gate :permissions="'edit test package'">
        <template #gated-content>
          <test-package-form :test_package="test_package" @submit="submit" />
        </template>
      </permission-alert-gate>
    </template>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import TestPackageForm from "@/components/lab/testpackage/form/TestPackageForm";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { getModel } from "@/shared/fetch-utils";
import { notificationOptions } from "@/shared/toast-notification-options";
import { testPackageNotifications } from "@/shared/notifications";

const TestPackageRepository = LabRepositoryFactory.get("testPackage");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "TestPackageEdit",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    TestPackageForm,
  },
  data() {
    return {
      loading: true,
      test_package_id: this.$route.params.test_package_id || null,
      test_package: null,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/testpackages",
            title: "Test package list",
          },
          {
            icon: "fa-eye",
            linkto: `/testpackages/${this.test_package_id}`,
            title: "View test package",
            variant: "info",
          },
        ],
      };
    },
    formattedName() {
      return `${this.test_package.sample_type.name} ${this.test_package.name}`;
    },
  },
  methods: {
    async submit(form_data) {
      try {
        await TestPackageRepository.update(this.test_package_id, form_data);
        this.editSuccess();
        this.$router.push(`/testpackages/${this.test_package_id}`);
      } catch ({ response }) {
        this.editFail();
      }
    },
  },
  async created() {
    this.loading = true;

    this.test_package = await getModel({
      model_type: "test_package",
      id: this.test_package_id,
      message: this.$bvToast,
    });

    this.loading = false;
  },
  notifications: testPackageNotifications,
};
</script>
